import request from "./axios";

export function getTokenAndBasicUserInfo(code) {
    return request.get("https://ddescholar.acemap.info/api/v2/token/callback", {
        params: {
            appcode: 'dataexpo',
            code
        },
    });
}

export function getTokenValidate(token) {
    return request.get("https://ddescholar.acemap.info/api/v2/token/log_out", {
        params: {
            token
        },
    });
}